module.exports = __webpack_public_path__ + "static/media/Edit.a2371d32.svg";